var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelivery = function SvgDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#delivery_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#061e21",
    d: "m28.899 18.02-2.862-5.725h-4.293V9.432A1.435 1.435 0 0 0 20.312 8H7.432A1.435 1.435 0 0 0 6 9.432v11.45l1.432 1.432h1.813a2.863 2.863 0 1 0 4.958 0h7.924a2.863 2.863 0 1 0 4.956 0h1.814v-4.295zm-7.157 0v-4.295h2.967l2.148 4.294z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "delivery_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h34v34H0z"
  })))));
};
export default SvgDelivery;